import React from 'react';
import { createPortal } from 'react-dom';

export default function DeleteDialog({ show, onClose, onConfirm, type = '' }) {
  if (!show) return null;

  const getTitle = () => {
    switch (type) {
      case 'policy':
        return 'Hapus Kebijakan?';
      case 'department':
        return 'Hapus Divisi?';
      case 'subdivision':
        return 'Hapus Sub Divisi?';
      case 'position':
        return 'Hapus Jabatan?';
      case 'role':
      case 'roles':
        return 'Hapus Role?';
      case 'skill':
        return 'Hapus Skill?';
      case 'grade':
      case 'salarygrade':
        return 'Hapus Grade Gaji?';
      case 'jobgrade':
        return 'Hapus Job Grade?';
      case 'mapping':
        return 'Hapus Mapping?';
      default:
        return 'Hapus Pegawai?';
    }
  };

  const getDescription = () => {
    switch (type) {
      case 'policy':
        return 'Kebijakan yang dihapus tidak dapat dikembalikan. Pastikan Anda sudah yakin untuk menghapus kebijakan ini.';
      case 'department':
        return 'Divisi yang dihapus tidak dapat dikembalikan. Pastikan Anda sudah yakin untuk menghapus data ini.';
      case 'subdivision':
        return 'Sub Divisi yang dihapus tidak dapat dikembalikan. Pastikan Anda sudah yakin untuk menghapus data ini.';
      case 'position':
        return 'Jabatan yang dihapus tidak dapat dikembalikan. Pastikan Anda sudah yakin untuk menghapus data ini.';
      case 'role':
      case 'roles':
        return 'Role yang dihapus tidak dapat dikembalikan. Pastikan Anda sudah yakin untuk menghapus data ini.';
      case 'skill':
        return 'Skill yang dihapus tidak dapat dikembalikan. Pastikan Anda sudah yakin untuk menghapus data ini.';
      case 'grade':
      case 'salarygrade':
        return 'Grade Gaji yang dihapus tidak dapat dikembalikan. Pastikan Anda sudah yakin untuk menghapus data ini.';
      case 'jobgrade':
        return 'Job Grade yang dihapus tidak dapat dikembalikan. Pastikan Anda sudah yakin untuk menghapus data ini.';
      case 'mapping':
        return 'Mapping yang dihapus tidak dapat dikembalikan. Pastikan Anda sudah yakin untuk menghapus data ini.';
      default:
        return 'Data pegawai yang dihapus tidak dapat dikembalikan. Pastikan Anda sudah yakin untuk menghapus data ini.';
    }
  };

  return createPortal(
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-lg p-6 max-w-md w-full animate-modal">
        <h3 className="text-lg font-semibold">{getTitle()}</h3>
        <p className="text-gray-500 mt-2">{getDescription()}</p>
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Batal
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
          >
            Hapus
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
